import { Component, OnInit, OnDestroy } from '@angular/core'
import { Observable, from, of, zip } from 'rxjs'
import { map, reduce, tap, switchMap, filter, takeUntil } from 'rxjs/operators'
import { ActivatedRoute, Router } from '@angular/router'
import { MenuItem, ConfirmationService, LazyLoadEvent } from 'primeng/api'
import { Store } from '@ngrx/store'
import { get } from 'lodash'

import { getValue } from '@app/shared/utils/feature-utils'
import { CollectionScreenComponent } from '@core/features/collection-screen.component'
import * as fromStore from '@app/core/store'
import {
  Column,
  ColumnGroup,
  ResponsiveResolution,
} from '@core/utils/collection.util'
import { FeatureService } from '@services/feature/feature.service'
import { CriteriaService } from '@app/core/services/criteria/criteria.service'
import * as fromParameters from '@features/parameters/search-security-portfolio-menu/store'
import { SecurityPortfolio as SecurityPortfolioModel } from '@models/security-portfolio.model'

import { environment } from '@env/environment'
import { Location } from '@angular/common'
import { MatDialogRef } from '@angular/material'
import { SecurityPortfolioService } from '@app/core/services-api/security-portfolio.service'
import { LocalService } from '@app/shared/services/local.service'
import { ProfileType } from '@app/custom-shared/enums/permissions-type.enum'
import { ProfileManagerService } from '@app/custom-shared/services/profile-manager.service'
/**
 * The base REST API path
 */
const BASE_PATH = environment.basePath
/**
 * Component that displays a collection of items.
 * This component is auto generated by `UI Studio` tool for a screen of type `Search`, please refer to our official documentation for more informations:
 * https://wiki.vermeg.com/pages/viewpage.action?spaceKey=PFD&title=Components+Store#ComponentsStore-Searchscreen
 *
 * It is not recommended to modify this component, but if you will need to customize it, you will have to skip its generation via the `cli-config.json` file and `you will have to maintain it`:
 * https://wiki.vermeg.com/display/PFD/Workspace+Properties#WorkspaceProperties-F3
 **/
@Component({
  selector: 'app-parameters-search-security-portfolio-menu',
  templateUrl: './parameters-search-security-portfolio-menu.component.html',
})
export class ParametersSearchSecurityPortfolioMenuComponent
  extends CollectionScreenComponent
  implements OnInit, OnDestroy {
  /**
   * The stored variables in NGRX State like `page`, `pageSize`, `keys`...etc
   */
  vars: any = {}
  /**
   * The selector of the `loading` state property, it displays a mask when receiving a `true` boolean value
   */
  loading$: Observable<boolean>
  /**
   * The Observable selector of the value property stored in NGRX State
   */
  value$: Observable<SecurityPortfolioModel[]>
  /**
   * The collection of data items loaded
   */
  value: SecurityPortfolioModel[]
  /**
   * The selected rows selector
   */
  rowsSelected$: Observable<SecurityPortfolioModel[]>
  /**
   * The technical keys of the configured columns
   */
  keys = `managerCode,managerName,administratorCode,administratorName`

  /**
   * The Observable selector of the current page property stored in NGRX State
   */
  currentPage$
  /**
   * The Observable selector of the page size property stored in NGRX State
   */
  pageSize$
  /**
   * The Observable selector of the total items number property stored in NGRX State
   */
  count$
  /**
   * The string criteria of the input filters
   */
  criteria

  /**
   *  The size of items per page
   **/
  pageSize = 10
  /**
   *  The collection of items
   **/
  items: SecurityPortfolioModel[]
  /**
   *  The collection of the selected items
   **/
  selectedItems: any;
  selectedPtfCode :any[]=[]

  rowOperations$: Observable<MenuItem[]>

  /** @inheritDoc */
  constructor(
    private profileManager: ProfileManagerService,
    public dialogRef: MatDialogRef<ParametersSearchSecurityPortfolioMenuComponent>,
    private featureService: FeatureService,
    private confirmationService: ConfirmationService,
    private criteriaService: CriteriaService,
    private location: Location,
    private secureStorage:LocalService,
    private service: SecurityPortfolioService,
    router: Router,
    store: Store<fromParameters.State>,
    route: ActivatedRoute
  ) {
    super(route, store, router)
  }
  /**
   * Initializes the state and value of the component by dispatching NGRX Actions
   * Selects and listens to the changes of some properties stored in the state
   */
  ngOnInit() {
    //this.value$ = this.service.findAllPtfConfiguration();
    this.service.findAllPtfConfiguration().subscribe(res=>{
      if (res){
        
        if (this.isOperator()){
          this.value = res
          this.value.forEach(element => {
            if(element?.currentConfig==true){
              this.selectedItems = element
            }
            
          });

        }
        else{
          let allConfs = [...res];
        const containsGlobalConfigs = res.some(element=>element.identifier.includes("GLOBOL_CONF_G_"))
        this.value = containsGlobalConfigs ? res.filter(element=>element.identifier.includes("GLOBOL_CONF_G_")).filter(globalConf=>{
          const nonGlobalConfs = allConfs.filter(item => !item.identifier.includes("GLOBOL_CONF_G_"));
          return nonGlobalConfs.some(item => item.portfolioCode === globalConf.portfolioCode)
        })  : res
        this.value.forEach(element => {
          if(element?.currentConfig==true){
            this.selectedItems = element
          }
          
        });
        //this.selectedItems = res[0]
      }

        }
        
      
    })

     
  }

  isOperator(): boolean {
      return this.profileManager.getProfile() == ProfileType.operator
    }
  /**
   * Dispatch the search Action
   */
  init() {
    this.store.dispatch(
      fromParameters.searchAction({
        ...this.params,
        activeRoute: this.activeRoute,
      })
    )
    this.currentPage$ = this.store.select(fromStore.selectPage, this.ctx)
    this.pageSize$ = this.store.select(fromStore.selectPageSize, this.ctx)
  }
  /**
   * Returns a decoded criteria parameter
   */
  getCriteria() {
    let criteria = this.activeRoute.snapshot.queryParams.criteria
    return criteria
  }
  /**
   * Returns the basic payload value
   */
  initParams(): any {
    return {
      totalItems: this.totalItems,
      page: 1,
      size: this.pageSize,
      keys: this.keys,
      order: this.orderBy,
      criteria: this.criteria,
      vars: {
        page: 1,
        size: this.pageSize,
        keys: this.keys,
        criteria: this.criteria,
      },
    }
  }

  /**
   * Get date format from the profile
   * @param {string} temporalType
   * @param {string} datePrecision
   * @return {string} the date format
   */
  getDateFormat(temporalType: string, datePrecision?: string): string {
    return this.featureService.profileService.getDateFormat(
      temporalType,
      datePrecision
    )
  }

  /**
   * Paginates the retrieved data
   * @param {PageChange} event - The PageChange event
   */
  paginate(event) {
    this.store.dispatch(
      fromParameters.searchAction({
        ...this.params,
        loading: true,
        size: event.rows,
        page: event.page + 1,
        vars: { ...this.vars, size: event.rows, page: event.page + 1 },
        activeRoute: this.activeRoute,
      })
    )
  }

  /**
   * Returns the payload value to be dispatched in the NGRX actions
   * @returns {object}
   */
  getActionPayload() {
    return {
      ...this.params,
      ctx: { ...this.ctx },
      activeRoute: this.activeRoute,
      vars: { ...this.vars, items: this.value },
      data:
        this.selectedItems instanceof Array
          ? this.selectedItems[0]
          : this.selectedItems,
      rowId: this.selectedItems ? this.selectedItems['code'] : undefined,
      value: this.value,
    }
  }
  /**
   * Dispatches an NGRX Action to select rows
   */
  onSelectionChange() {
    this.store.dispatch(
      fromParameters.rowsSelectionChangeAction({
        ...this.params,
        rowsSelected: [this.selectedItems],
      })
    )
  }
  /***
   * Executes the cancel action
   * @return {void}
   **/
  doCancel(): void {
    this.dialogRef.close()
  }

  /***
   * Executes the select action
   * @return {void}
   **/
  doSelect(): void {
    this.service.setCurrentPTFConfig(this.selectedItems.identifier).subscribe(res=>{
      this.secureStorage.setJsonValue('portfolioCode', JSON.stringify(this.selectedItems));
      this.secureStorage.setJsonValue('PortfolioConfigCode', JSON.stringify(this.selectedItems));
      this.dialogRef.close();
      location.reload();
      
    })

    
  }

  formatIdentifier(identifier: string | undefined): string {
    
  
    if (identifier && identifier.startsWith("GLOBOL_CONF_G_")) {
      const ptfCode = identifier.split("_G_")[1];
      return `GLOBAL_${ptfCode}`;
    }
  
    return identifier;
  }
  

  ngOnDestroy() {
    this.destroy$.next(true)
    this.destroy$.complete()
  }
}
